export const assertNever = (value: never, customError?: string): never => {
  throw new Error(customError ?? `Unhandled value: ${value as string}`);
};
